import { useState } from 'react'
import { Box, Body, Input } from '..'
import './CreditCard.scss'

export const CreditCard = ({ value: { name, number, exp_month, exp_year, cvc }, onChange, dark }) => {
  const [creditCardDetails, setCreditCardDetails] = useState({
    name: name || '',
    number: number || '',
    exp_month: exp_month || '',
    exp_year: exp_year || '',
    cvc: cvc || ''
  })

  const [creditCardValidation, setCreditCardValidation] = useState({
    name: true,
    number: true,
    expiry: true,
    cvc: true
  })

  const cleanCardNumber = (value) => value.replace(/\D/g, '')

  const setAndFocusAfter = (length, field, nextField, pattern) => e => {
    const value = field === 'number' ? cleanCardNumber(e.target.value) : e.target.value

    if(pattern && pattern.test(value) || !pattern || value === '') {
      setCreditCardDetails({...creditCardDetails, [field]: value})
      onChange({...creditCardDetails, [field]: value})
    } else {
      return
    }

    if(value.length === length) {
      document.getElementById(nextField) ? document.getElementById(nextField).focus() : document.getElementById(field).blur()
    }
  }

  const validateInput = (field, pattern) => e => setCreditCardValidation({
    ...creditCardValidation,
    [field]: pattern.test(field === 'number' ? cleanCardNumber(e.target.value) : e.target.value)
  })

  const validateExpiry = (field) => e => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear() % 100

    const year = field === 'exp_year' ? parseInt(e.target.value) : parseInt(creditCardDetails.exp_year)
    const month = field === 'exp_month' ? parseInt(e.target.value) : parseInt(creditCardDetails.exp_month)

    setCreditCardValidation({
      ...creditCardValidation,
      expiry: (month <= 12 && month > 0) && ((year > currentYear) || (year === currentYear && month >= currentMonth))
    })
  }

  return <Box className="inputs-container" column>
    <Input
      title="Name on card"
      id="name"
      name="name"
      value={creditCardDetails.name}
      onChange={setAndFocusAfter(-1, 'name')}
      onBlur={validateInput('name', /^[A-Za-z\s'-]{2,}$/)}
      error={!creditCardValidation.name}
      required
      dark={dark}
    />
    <Input
      title="Card Number"
      id="number"
      name="number"
      value={creditCardDetails.number && creditCardDetails.number.replace(/(.{4})/g, '$1 ').trim()}
      onChange={setAndFocusAfter(16, 'number', 'exp_month', /^[0-9\b]+$/)}
      onBlur={validateInput('number', /^\d{16}$/)}
      error={!creditCardValidation.number}
      required
      maxLength={19}
      dark={dark}
    />

    <Box gap={16}>
      <Box
        column
        className={`input-outer-container expiry-container${dark ? ' dark' : ''}${(!creditCardValidation.expiry) ? ' error' : ''}`}
        fullWidth
      >
        <Body alt weight={600}>
          Expiry
        </Body>
        <Box alignItems="center" className="input-container expiry-inputs">
          <input
            id="exp_month"
            name="exp_month"
            value={creditCardDetails.exp_month}
            onChange={setAndFocusAfter(2, 'exp_month', 'exp_year', /^[0-9\b]+$/)}
            onBlur={validateExpiry('exp_month')}
            required
            maxLength={2}
          />
          <Body className="expiry-divider">/</Body>
          <input
            id="exp_year"
            name="exp_year"
            value={creditCardDetails.exp_year}
            onChange={setAndFocusAfter(2, 'exp_year', 'cvc', /^[0-9\b]+$/)}
            onBlur={validateExpiry('exp_year', /^(0?[1-9]|1[0-2])$/)}
            required
            maxLength={2}
          />
        </Box>
      </Box>

      <Input
        title="CVC"
        id="cvc"
        name="cvc"
        onChange={setAndFocusAfter(4, 'cvc', null, /^[0-9\b]+$/)}
        value={creditCardDetails.cvc}
        onBlur={validateInput('cvc', /^\d{3,4}$/)}
        error={!creditCardValidation.cvc}
        required
        maxLength={4}
        dark={dark}
      />
    </Box>
  </Box>
}